import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import {
    createStrapiMediaUrl,
    ImageModel,
    useAppSelector,
} from 'shared';
// eslint-disable-next-line no-restricted-imports
import {
    fetchBestImagesGroupThunk,
} from 'shared/lib';
import BaseError from '../../../utils/base-error';

export type ImagesBlockState = {
    loaded: boolean
    images: ImageModel[]
    errors: BaseError[]
}

const initialState: ImagesBlockState = {
    loaded: false,
    images: [],
    errors: [],
};

// eslint-disable-next-line import/prefer-default-export
export const imagesBlockSlice = createSlice({
    name: 'imagesBlockSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchBestImagesGroupThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.images = response.data.data.images?.map(({ url }) => ({
                        url: createStrapiMediaUrl(url),
                    })) || [];
                }
                state.loaded = true;
            },
        );
    },
});

export const useImagesBlockState = () => useAppSelector((store) => store.imagesBlock);
